import React from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';

import {
  QuestionRelationDefaultProps,
  QuestionRelationPropTypes,
} from 'src/components/JobDatasheet/propTypes';
import SelectBox from 'src/components/SelectBox';

const MenuList = props => (
  <components.MenuList {...props}>{props.children}</components.MenuList>
);

MenuList.propTypes = {
  children: PropTypes.any,
};

export const QuestionRelation = ({
  flash,
  isRectifiedQuestion,
  onChange,
  question: {
    relationSettings: { allowMultiSelect, entityItems },
  },
  value,
  disableChange,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';
  const selectOptions = (entityItems || []).map(v => ({
    value: v,
    label: v,
  }));

  const realValue = value ? value[selectedValueKey] : null;
  let selectValue = selectOptions.find(v => v.value === realValue) || null;
  if (allowMultiSelect) {
    selectValue = selectOptions.filter(
      v => (realValue || []).indexOf(v.value) !== -1,
    );
  }

  const getReturnObject = (e, withMultiSelect) => {
    const returnObject = {
      ...value,
      type: 'relation',
    };

    let returnValue;

    if (withMultiSelect) {
      returnValue = e ? e.map(v => v.value) : [];
    } else {
      returnValue = e ? e.value : null;
    }

    returnObject[selectedValueKey] = returnValue;

    return returnObject;
  };

  return (
    <SelectBox
      components={{ MenuList }}
      flash={flash}
      isClearable={true}
      isMulti={allowMultiSelect}
      onChange={!disableChange && ((e) => onChange(getReturnObject(e, allowMultiSelect)))}
      options={selectOptions}
      value={selectValue}
    />
  );
};

QuestionRelation.propTypes = QuestionRelationPropTypes;
QuestionRelation.defaultProps = QuestionRelationDefaultProps;
